<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <div class="grid-menu grid-menu-2col">
        <div class="no-gutters row">

<!--          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="stock-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>-->

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('stock-place-product')"
                      to="stock-place-product">
              <i class="lnr-inbox btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Locais de Produtos
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('stock-place-mold')"
                      to="stock-place-mold">
              <i class="lnr-layers btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Locais de Moldes
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('stock-type-manual')"
                      to="stock-type-manual">
              <i class="lnr-layers btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Tipos Operações Manuais
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('stock-type-expedition-status')"
                      to="stock-type-expedition-status">
              <i class="lnr-file-empty btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Status de Expedição
            </t-button>
          </div>


        </div>
      </div>


<!--      <b-col v-for="relationPages in userAuth.relationPages" :key="relationPages.pageRelationId">
        {{ relationPages.pageTitle }}
      </b-col>-->

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'ProductionSetting',
  data() {
    return {

    }
  },
  methods: {

    mountedPrepare(){


    },
    async mountedContinued(){

    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
